import React from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import { Field, Input, FluentProvider, webLightTheme } from '@fluentui/react-components';

interface ICompanyCodeInputProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormMethods<any>;
  defaultValue: string | number;
  codeLength?: number;
  fieldName: string;
  label: string;
  readOnly?: boolean;
}

const CompanyCodeInput = ({
  form,
  defaultValue,
  codeLength,
  fieldName,
  label,
  readOnly,
}: ICompanyCodeInputProps): JSX.Element => {
  const { control, errors, setValue } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Controller
        control={control}
        name={fieldName}
        defaultValue={defaultValue || ''}
        rules={{
          required: `${label} is required`,
          min: {
            value: 1,
            message: `${label} has to be a number greater than 0`,
          },
          minLength: {
            value: codeLength,
            message: `${label} must be ${codeLength} digits long`,
          },
          maxLength: {
            value: codeLength,
            message: `${label} must be ${codeLength} digits long`,
          },
          pattern: {
            value: /^[1-9][0-9]+$/i,
            message: `${label} must be a whole number that does not start with 0`,
          },
        }}
        render={({ onChange, onBlur, value, name, ref }) => (
          <Field label={label} required validationMessage={errors[fieldName]?.message}>
            <Input
              id={fieldName}
              type="text"
              readOnly={readOnly}
              disabled={readOnly}
              value={value}
              name={name}
              ref={ref}
              onBlur={onBlur}
              onChange={(ev, data) => {
                onChange(data.value);
                setValue(fieldName, data.value);
              }}
            />
          </Field>
        )}
      />
    </FluentProvider>
  );
};

export default CompanyCodeInput;
